import { forwardRef } from 'react';

export const UiCheckbox = forwardRef(function UiCheckbox(
  { label, className = '', style, ...inputProps },
  ref,
) {
  return (
    <label className={`ui-check ${className}`.trim()} style={style}>
      <input {...inputProps} ref={ref} type="checkbox" className="ui-check__input" />
      <span className="ui-check__box" aria-hidden />
      {label ? <span className="ui-check__label">{label}</span> : null}
    </label>
  );
});
